"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStatusList = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importDefault(require("react"));
const FormStatusListItem = core_1.getComponent('FormStatusListItem');
const FormStatusList = ({ items, type }) => {
    if (!items || items.length < 1) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, items.map((status, index) => (react_1.default.createElement(FormStatusListItem, { key: index, divider: index < items.length - 1, type: type, testID: "FormStatusList-loop" }, status)))));
};
exports.FormStatusList = FormStatusList;
exports.FormStatusList.defaultProps = {
    type: 'error',
};
